import request from '@/api/request'


//查询所有学科分类
export function selectMajorForm(params) {
	return request({ url: '/api/Mojor/selectMajorForm',method: 'post',data:params})
}

//根据学科分类查询一级学科
export function selectOneMajor(params) {
	return request({ url: '/api/Mojor/selectOneMajor',method: 'post',data: params})
}

//根据学科分类和一级学科查询专业
export function selectMajorList(params) {
	return request({ url: '/api/Mojor/selectMajorList',method: 'post',data: params})
}

//获取当前志愿单的筛选条件
export function screenFind(params) {
	return request({ url: '/api/Mojor/screenFind',method: 'post',data: params})
}

//保存当前志愿单的筛选条件
export function screenFindSave(params) {
	return request({ url: '/api/Mojor/screenFindSave',method: 'post',data: params})
}



// WEBPACK FOOTER //
// ./src/api/admin/volunteer/selectMajor.js